const fileInputs = document.querySelectorAll(".upload__input");
const fileNameSpans = document.querySelectorAll(".upload__text");

fileInputs.forEach((input, index) => {
    input.addEventListener("change", function () {
        const fileName = input.files[0].name;
        fileNameSpans[index].textContent = fileName;
    });
});
